import { Form } from "antd/es";
import React from "react";

import { cx } from "~/tools/class-variance";

import styles from "./_form-item.module.css";

export interface FormItemProps {
	addColon?: boolean;
	className?: string;
	error?: string | false;
	label?: React.ReactNode;
	required?: boolean;
	help?: React.ReactNode;
	labelExtra?: React.ReactNode;
	name?: string;
	noStyle?: boolean;
}
export const FormItem: React.FC<React.PropsWithChildren<FormItemProps>> = ({
	className,
	addColon = false,
	error,
	help,
	label,
	required,
	children,
	name,
	labelExtra,
	noStyle,
}) => (
	<Form.Item
		className={cx(styles.formItem, className)}
		colon={addColon}
		help={error || help}
		htmlFor={name}
		label={label ? <FormItemLabel label={label} labelExtra={labelExtra} required={required} /> : undefined}
		noStyle={noStyle}
		validateStatus={error ? "error" : undefined}
	>
		{children}
	</Form.Item>
);

interface FormItemLabel {
	label?: React.ReactNode;
	required?: boolean;
	labelExtra?: React.ReactNode;
}

export const FormItemLabel: React.FC<FormItemLabel> = ({ label, required, labelExtra }) => (
	<span className="flex items-center font-medium text-15 text-grey-900 leading-5.5" data-testid="form-item-label">
		{label}
		{required && (
			<span className="ml-1 inline-block self-start font-normal leading-none" data-testid="form-item-required">
				{required ? "*" : ""}
			</span>
		)}
		{labelExtra && <span className="ml-2 h-[22px]">{labelExtra}</span>}
	</span>
);
